import type { CrossDomainFinding, Finding } from '@/model/Agent.model';
import type { FC } from 'react';
import SendBlockingMark from './SendBlockingMark';
import SendSeverityBadge from './SendSeverityBadge';
import SendSeveritySource from './SendSeveritySource';
import { severityLevelOf } from '@/components/Agents/SendValidator/utils/SendSeverity';

interface SendFindingSeverityProps {
  finding: Finding | CrossDomainFinding;
}

/**
 * How serious a finding is, as the report draws it on every finding: its level, whether a published grading
 * blocks submission on it, and where that grading came from.
 */
const SendFindingSeverity: FC<SendFindingSeverityProps> = ({ finding }) => (
  <>
    <SendSeverityBadge level={severityLevelOf(finding)} />
    <SendBlockingMark finding={finding} />
    <SendSeveritySource finding={finding} />
  </>
);

export default SendFindingSeverity;
